import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteOfficeGroupSaga,
  getOfficeGroupDetailsSaga,
  getOfficeGroupListSaga,
} from "src/store/officegroups/saga";
import {
  OfficeGroupDetailDto,
  OfficeGroupDto,
} from "src/store/officegroups/type";
import OfficeGroupCreateForm from "./create";
import OfficeGroupEditForm from "./edit";
const OfficeGroupPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<OfficeGroupDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<OfficeGroupDetailDto>();
  const columns = [
    {
      text: t("OfficeGroup.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("OfficeGroup.PageTitle")}
        metaTag={t("OfficeGroup.MetaTag")}
        gridProps={{
          addTitle: t("OfficeGroup.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getOfficeGroupListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getOfficeGroupDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: OfficeGroupDto) =>
              t("OfficeGroup.DeleteQA", {
                name: data.Name,
              }),
            action: deleteOfficeGroupSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <OfficeGroupCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getOfficeGroupListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <OfficeGroupEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getOfficeGroupListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default OfficeGroupPage;
